// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-popover][data-v-1fb7308e]{padding:0}@media (max-width:1023.5px){[data-popover].dropdown-position-top[data-v-1fb7308e]{transform:translate(40px)}}[data-popover][data-v-1fb7308e]:before{border-top:6px solid #070707}[data-popover].dropdown-position-right[data-v-1fb7308e]:before{border:6px solid transparent;border-right-color:#070707;left:-12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
